import './ui.css';

export default function ProjectCard({ name, desc, stars, lang, url, demo }) {
  return (
    <a href={url} className="project-card" target="_blank" rel="noopener noreferrer">
      <div className="project-header">
        <span className="project-name">{name}</span>
        <span className="project-stars">★ {stars}</span>
      </div>
      <p className="project-desc">{desc}</p>
      <div className="project-meta">
        <span className="lang">{lang}</span>
        <span>{demo ? 'live →' : 'repo →'}</span>
      </div>
    </a>
  );
}
